<template>
  <div>            
    <b-button class="buttonClass" type="submit" name="resetConf" id="resetConf" variant="warning" size="sm" @click="showModalPopupResetConf()">
      <i class="fas fa-undo-alt"></i>
      <span class="text-uppercase" style="font-size:12px;font-weight:bold;margin-left:5px">Restaurar valores iniciales</span>
    </b-button>
  
    <b-button class="buttonClass" type="reset" name="sendConf" id="sendConf" variant="warning" size="sm" @click="showModalPopupSendConf()">
      <i class="fas fa-file-export"></i>
      <span class="text-uppercase" style="font-size:12px;font-weight:bold;margin-left:5px">Forzar envío configuración</span>
    </b-button>           
  </div>
</template>


<script>
import BitacoraService from "@/services/BitacoraService";
import ConfigurationService from "@/services/ConfigurationService";

export default {
  name: "configuration-actions",
  data() {
    return {
    };
  },
  methods: {

    resetConfiguration() {
      ConfigurationService.setDefaultConfiguration()
        .then(() => {
          console.log();
          this.$notify({
             group: 'notificateDiv',
             type: 'success',
             title: 'Mensaje',
             text: 'Se han restaurado los valores iniciales correctamente',
             duration: 3000,
             speed: 1000
          });
          //LOGS
          BitacoraService.write("INFO", "Configuracion: Se ha reseteado 1 configuración de la lista");
          //delay antes de rehabilitarlos
          setTimeout(()=>{
          },500);
          //Refresh table list (parent signal)
          this.$emit('onClickReset')
        })
        .catch(e => {
          console.log(e);
          //Mensaje de actualización
          this.$notify({
             group: 'notificateDiv',
             type: 'pepito',
             title: 'Error',
             text: 'No se han restaurado los valores iniciales, es decir los valores por defecto',
             duration: 3000,
             speed: 1000
          });
           //LOGS
          BitacoraService.write("ERROR", "Configuracion: No se ha podido modificar 1 configuración de la lista")         
        });
    },

    sendConfiguration() {
      ConfigurationService.sendConfiguration()
        .then(() => {
          this.$notify({
             group: 'notificateDiv',
             type: 'success',
             title: 'Mensaje',
             text: 'Envío de la configuracion realizada correctamente',
             duration: 3000,
             speed: 1000
          });
          //LOGS
          BitacoraService.write("INFO", "Configuracion: Se ha enviado 1 configuración")
        })
        .catch(e => {
          console.log(e);
          //Mensaje de actualización
          this.$notify({
             group: 'notificateDiv',
             type: 'pepito',
             title: 'Error',
             text: 'Error en el envío de la configuracion.',
             duration: 3000,
             speed: 1000
          });
           //LOGS
          BitacoraService.write("ERROR", "Configuracion: No se ha podido realizar el envío de 1 configuración")         
        });
    },

    showModalPopupResetConf() {
      this.$bvModal.msgBoxConfirm('¿Desea restaurar los valores iniciales, es decir los valores por defecto?', {
        title: 'Confirmación',
        buttonSize: 'sm',
        okTitle: 'Si',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
        })
        .then(value => {
          if (value == true){
            this.resetConfiguration();
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    
    showModalPopupSendConf() {
      this.$bvModal.msgBoxConfirm('¿Desea forzar un envío configuración?', {
        title: 'Confirmación',
        buttonSize: 'sm',
        okTitle: 'Si',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
        })
        .then(value => {
          if (value == true){
            this.sendConfiguration();
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    }
  },
  mounted() {
  }
};
</script>

<style scoped>

  .buttonClass{
    margin:16px;
  }

</style>